import { apiFetch } from './api';
import { FILE_EXTENSIONS } from './mediaTypes';

// Generate FILE_TYPES mapping from shared constants
const createFileTypesMap = () => {
  const fileTypes: Record<string, string> = {};
  
  // Images
  FILE_EXTENSIONS.IMAGE.forEach(ext => fileTypes[ext] = "photo");
  
  // Videos
  FILE_EXTENSIONS.VIDEO.forEach(ext => fileTypes[ext] = "video");
  
  // Audio
  FILE_EXTENSIONS.AUDIO.forEach(ext => fileTypes[ext] = "audio");
  
  // PDF
  FILE_EXTENSIONS.PDF.forEach(ext => fileTypes[ext] = "pdf");
  
  // Documents
  FILE_EXTENSIONS.DOCUMENT.forEach(ext => fileTypes[ext] = "document");
  
  // Additional types not in shared constants
  fileTypes.xlsx = "spreadsheet";
  fileTypes.csv = "spreadsheet";
  fileTypes.pptx = "presentation";
  
  return fileTypes;
};

const FILE_TYPES = createFileTypesMap();

export const inferFileType = (filename: string): string => {
  const ext = filename.toLowerCase().split('.').pop() || '';
  return FILE_TYPES[ext as keyof typeof FILE_TYPES] || "other";
};

export const isPreviewable = (type: string): boolean => {
  return ["photo", "pdf", "video", "audio"].includes(type);
};

export interface UploadData {
  file: File;
  name: string;
  description: string;
  type: string;
  countryAreaIds?: number[];
  placeIds?: number[];
  restrictionIds?: number[];
  partnerIds?: number[];
  tripIds?: number[];
  specialThingIds?: number[];
  tagIds?: number[];
  peopleIds?: number[];
}

export const handleUpload = async (uploadData: UploadData) => {
  const formData = new FormData();
  formData.append('file', uploadData.file);
  formData.append('name', uploadData.name);
  formData.append('description', uploadData.description);
  formData.append('type', uploadData.type);
  formData.append('country_area_ids', JSON.stringify(uploadData.countryAreaIds));
  formData.append('place_ids', JSON.stringify(uploadData.placeIds));
  formData.append('restriction_ids', JSON.stringify(uploadData.restrictionIds));
  formData.append('partner_ids', JSON.stringify(uploadData.partnerIds));
  formData.append('trip_ids', JSON.stringify(uploadData.tripIds));
  formData.append('special_thing_ids', JSON.stringify(uploadData.specialThingIds));
  formData.append('tag_ids', JSON.stringify(uploadData.tagIds));
  formData.append('people_ids', JSON.stringify(uploadData.peopleIds));

  await apiFetch(`${process.env.REACT_APP_API_ROOT}media/`, {
    method: 'POST',
    headers: {
      // Don't set Content-Type here as it's set by FormData
    },
    body: formData
  });
}; 